import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import Header from './Header';
import axios from 'axios';
import HodCommentFormContent from './HodCommentFormContent'
import './HodCommentFormReport.css'
const HodCommentFormReport = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isDataColumnHOD, setFormDataColumnHOD] = useState(false);
    const { REACT_APP_API_BACKEND_URL, REACT_APP_API_BACKEND_URL_EXIT_FORM } = process.env;

    async function fetchDataColumnHOD() {
        try {

            const response = await axios.get(
                REACT_APP_API_BACKEND_URL_EXIT_FORM + 'column/hod/',
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    }
                }
            );

            setFormDataColumnHOD(response.data)
            setIsLoading(false);
            return response.data || [];
        } catch (err) {
            console.error('Error fetching exit form data:', err);
            return [];
        }
    };
    useEffect(() => {
        fetchDataColumnHOD()
    }, []);

    const HodCommentFormReport = () => {
        return (
            <Fragment>
                {isDataColumnHOD.length > 0 ? (
                    <HodCommentFormContent isDataColumnHOD={isDataColumnHOD} token={props.cognitoToken.idToken.jwtToken} />
                ) : (
                    <div>No data to show</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${props.isActive ? 'container is-active' : 'container-fluid'
                            }`}
                    >
                        <Header />
                        <div className='table-wrapper'>
                            <HodCommentFormReport />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}
export default HodCommentFormReport;